import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { useStore } from "../../context/StoreContext";

export const WhatsAppButton = () => {
  const { settings } = useStore();
  const { lang } = useLang();
  const { pathname } = useLocation();
  const num = (settings?.contact?.whatsapp || "").replace(/\D/g, "");
  if (!num || pathname.startsWith("/checkout")) return null;
  const text = encodeURIComponent(lang === "ar" ? `السلام عليكم، عندي استفسار من متجر قمر: ${window.location.href}` : `Hello, I have a question from QAMAR: ${window.location.href}`);
  return (
    <a href={`https://wa.me/${num}?text=${text}`} target="_blank" rel="noreferrer" data-testid="whatsapp-float-button"
      aria-label="WhatsApp"
      className="fixed bottom-5 end-5 z-30 grid h-14 w-14 place-items-center rounded-full bg-ink text-gold shadow-lg transition-transform duration-300 hover:scale-105">
      <MessageCircle size={24} strokeWidth={1.5} />
    </a>
  );
};
